import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';

interface Event {
  customerId: string;
  name: string;
  timestamp: string;
  data: any;
}

interface PreviewRowArgs {
  event: Event;
  expanded?: boolean;
}

export default class PreviewRowController extends Component<PreviewRowArgs> {
  @tracked expanded = false;

  get event() {
    return {
      ...this.args.event,
      data: JSON.parse(this.args.event.data),
    };
  }

  @action
  toggleExpanded() {
    this.expanded = !this.expanded;
  }
}
